import React, { memo, ReactElement, SVGAttributes } from "react";
import { TimerWidgetV4 } from "./v4";
interface TimerWidgetProps {
    isPlaying: boolean;
    duration: number;
    colors: { colorCode: string; duration: number }[];
    size?: number;
    trailColor?: string;
    strokeWidth?: number;
    strokeLinecap?: SVGAttributes<SVGImageElement>["strokeLinecap"];
    startAt?: number;
}

function TimerWidget(props: TimerWidgetProps): ReactElement {
    return <TimerWidgetV4 {...props} />;
}

export default memo(TimerWidget);
